import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDashboardDialog } from '@actions/dashboard-actions';
import {
  addToGroups,
  fetchGroupsData
} from '@actions/groups-actions';
import { getGroupTypesConfig } from '@constants/config';
import * as dialog from '@constants/dialogs';
import ChipsAddToGroup from '@shared/chips-add-to-group';
import Dialog from '@shared/dialogs/dialog';
import DialogActions from '@shared/dialogs/dialog-actions';
import {
  findGroupType,
  prepareGroupsForBulkAdd
} from '@utils/group-utils';

const AddToGroupExcludeOverlapDialog = () => {
  const dispatch = useDispatch();

  const activeDialogs = useSelector(state => state.dashboard.activeDialogs);
  const dialogData = useSelector(state => state.groups.dialog);

  const [groupType] = useState(getGroupTypesConfig()[0].id);
  const [selectedGroups, setSelectedGroups] = useState([]);

  useEffect(() => {
    dispatch(fetchGroupsData());
  }, [dispatch]);

  const handleCancel = useCallback(() => {
    dispatch(closeDashboardDialog(dialog.ADD_TO_GROUP_EXCLUDE_OVERLAP));
  }, [dispatch]);

  const handleSubmit = useCallback(() => {
    const { addDataId, addDataType, addDataExtra } = dialogData;
    const payload = prepareGroupsForBulkAdd({
      selectedGroups,
      entityIds: [addDataId],
      includeOverlaps: false
    });
    const selectedGroupType = findGroupType(groupType);
    dispatch(closeDashboardDialog(dialog.ADD_TO_GROUP_EXCLUDE_OVERLAP));
    dispatch(addToGroups(selectedGroupType.name, payload, addDataType, false, addDataExtra));
  }, [dialogData, dispatch, groupType, selectedGroups]);

  const getActions = useCallback(() => {
    const active = selectedGroups.length > 0 && dialogData.addDataId && dialogData.addDataType;
    return (
      <DialogActions
        disabledSubmit={!active}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        submitLabel="SAVE"
      />
    );
  }, [dialogData, handleCancel, handleSubmit, selectedGroups]);

  if (!activeDialogs[dialog.ADD_TO_GROUP_EXCLUDE_OVERLAP]) {
    return null;
  }

  const { addDataGroups, addDataType } = dialogData;
  const selectedGroupType = findGroupType(groupType);

  // Build groups list to display as Chips:
  const groups = addDataGroups.map(group => {
    const { id, name } = group;
    const selected = selectedGroups.includes(group.id);
    return { id, name, selected };
  });

  return (
    <Dialog
      actions={getActions()}
      title="Exclude overlap"
    >
      <ChipsAddToGroup
        dataType={addDataType}
        groups={groups}
        groupTypeName={selectedGroupType.name}
        setSelectedGroups={setSelectedGroups}
      />
    </Dialog>
  );
};

export default AddToGroupExcludeOverlapDialog;
